export default __webpack_public_path__ + "static/media/icon_privacy_home_transparency_icon-3.1a0761f7.svg";